// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_PlayerPage__F4tp2{
    width: 100%;
    overflow: auto;
    align-items: center;
}
.styles_ContentContainer__ydIiY{
    min-width: min-content;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}
.styles_FormContainer__FYVQU {
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: start;
}
.styles_ControlPanel__vUVMp{
    width: 100%;
    display: flex;
    justify-content: start;
}
.styles_ControlPanel__vUVMp > *{
    margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PlayersPage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".PlayerPage{\n    width: 100%;\n    overflow: auto;\n    align-items: center;\n}\n.ContentContainer{\n    min-width: min-content;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n}\n.FormContainer {\n    max-width: 1200px;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n}\n.ControlPanel{\n    width: 100%;\n    display: flex;\n    justify-content: start;\n}\n.ControlPanel > *{\n    margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PlayerPage": `styles_PlayerPage__F4tp2`,
	"ContentContainer": `styles_ContentContainer__ydIiY`,
	"FormContainer": `styles_FormContainer__FYVQU`,
	"ControlPanel": `styles_ControlPanel__vUVMp`
};
export default ___CSS_LOADER_EXPORT___;
